import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
import { useI18n } from '@/i18n/I18nContext';
import { FAQ as FAQ_IDS } from '@/constants/testIds';

export const FAQ = () => {
  const { t } = useI18n();
  const [openIdx, setOpenIdx] = useState(0);
  const items = t('faq.items') || [];

  return (
    <section
      id="faq"
      data-testid={FAQ_IDS.root}
      className="relative py-24 sm:py-32 bg-[#050D17]"
    >
      <div className="container mx-auto px-6">
        <div className="max-w-3xl">
          <div className="flex items-center gap-3 mb-5">
            <span className="h-px w-10 bg-[#C9A24E]" />
            <span className="text-[11px] uppercase tracking-[0.32em] text-[#C9A24E]">
              {t('faq.eyebrow')}
            </span>
          </div>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-[#F2F5F8] leading-[1.1]">
            {t('faq.title')}
          </h2>
          <p className="mt-6 text-[15px] sm:text-base text-[#C9D2E2] leading-relaxed max-w-2xl">
            {t('faq.subtitle')}
          </p>
        </div>

        <div className="mt-14 max-w-4xl">
          {items.map((item, idx) => {
            const isOpen = idx === openIdx;
            return (
              <div
                key={idx}
                data-testid={FAQ_IDS.item(idx)}
                className="border-t border-[#C9A24E]/20 last:border-b"
              >
                <button
                  data-testid={FAQ_IDS.trigger(idx)}
                  onClick={() => setOpenIdx(isOpen ? -1 : idx)}
                  aria-expanded={isOpen}
                  className="w-full flex items-start justify-between gap-6 py-6 text-left group"
                >
                  <h3 className="font-serif text-lg sm:text-xl text-[#F2F5F8] leading-snug group-hover:text-[#E6CC80] transition-colors">
                    {item.q}
                  </h3>
                  <span className="shrink-0 mt-1 h-8 w-8 flex items-center justify-center border border-[#C9A24E]/40 text-[#C9A24E] group-hover:border-[#C9A24E] transition-colors">
                    {isOpen ? <Minus size={14} /> : <Plus size={14} />}
                  </span>
                </button>
                <div
                  className={`grid transition-[grid-template-rows] duration-300 ease-out ${
                    isOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="pb-7 pr-12 text-[15px] text-[#C9D2E2] leading-relaxed">
                      {item.a}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
